/**
 * Product Card LOP - JavaScript para funcionalidad de swatches
 * Versión: 3.0.0
 * Autor: LOP Development Team
 */

(function() {
  'use strict';

  // Configuración
  const LOP_CONFIG = {
    maxSwatches: 5,
    navigationDelay: 300,
    loadingClass: 'loading',
    errorClass: 'error',
    hoverClass: 'hover'
  };

  // Clases CSS
  const LOP_CLASSES = {
    swatchesContainer: 'LOP-product-card-swatches-container',
    swatchItem: 'LOP-product-card-swatch-item',
    swatchLink: 'LOP-product-card-swatch-link',
    swatchImage: 'LOP-product-card-swatch-image'
  };

  /**
   * Clase principal para manejar Product Card LOP
   */
  class ProductCardLOP {
    constructor() {
      this.initialized = false;
      this.init();
    }

    /**
     * Inicializar la funcionalidad
     */
    init() {
      if (this.initialized) return;
      
      console.log('Product Card LOP: Inicializando...');
      
      // Inicializar swatches existentes
      this.initSwatches();
      
      // Observar cambios en el DOM para nuevos swatches
      this.observeDOM();
      
      // Verificar swatches después de la carga
      this.checkSwatchesAfterLoad();
      
      // Cargar datos de productos faltantes después de un delay
      setTimeout(() => {
        this.loadMissingProductData();
      }, 1000);
      
      this.initialized = true;
      console.log('Product Card LOP: Inicializado correctamente');
    }

    /**
     * Inicializar swatches existentes
     */
    initSwatches() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Inicializando ${swatches.length} swatches`);
      
      swatches.forEach((swatch, index) => {
        this.setupSwatch(swatch, index);
      });
    }

    /**
     * Configurar un swatch individual
     */
    setupSwatch(swatch, index) {
      if (!swatch.dataset.productHandle) {
        console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        return;
      }

      // Remover eventos existentes para evitar duplicados
      const newSwatch = swatch.cloneNode(true);
      swatch.parentNode.replaceChild(newSwatch, swatch);
      
      // Configurar eventos en el nuevo swatch
      this.addSwatchEvents(newSwatch, index);
      
      console.log(`Product Card LOP: Swatch ${index} configurado - ${newSwatch.dataset.productHandle}`);
    }

    /**
     * Añadir eventos a un swatch
     */
    addSwatchEvents(swatch, index) {
      const link = swatch.querySelector(`.${LOP_CLASSES.swatchLink}`);
      
      if (link) {
        // Evento de click
        link.addEventListener('click', (e) => {
          this.handleSwatchClick(e, swatch);
        });
        
        // Eventos de hover
        swatch.addEventListener('mouseenter', () => {
          this.handleSwatchHover(swatch, true);
        });
        
        swatch.addEventListener('mouseleave', () => {
          this.handleSwatchHover(swatch, false);
        });
        
        // Evento de focus para accesibilidad
        swatch.addEventListener('focus', () => {
          this.handleSwatchFocus(swatch);
        });
      }
    }

    /**
     * Manejar click en swatch
     */
    handleSwatchClick(e, swatch) {
      e.preventDefault();
      e.stopPropagation();
      
      const productHandle = swatch.dataset.productHandle;
      if (!productHandle) {
        console.error('Product Card LOP: No se encontró product handle');
        return;
      }

      console.log(`Product Card LOP: Navegando a producto: ${productHandle}`);

      // Añadir clase de carga
      swatch.classList.add(LOP_CONFIG.loadingClass);

      // Navegar al producto después del delay
      setTimeout(() => {
        try {
          window.location.href = `/products/${productHandle}`;
        } catch (error) {
          console.error('Product Card LOP: Error al navegar:', error);
          swatch.classList.remove(LOP_CONFIG.loadingClass);
          swatch.classList.add(LOP_CONFIG.errorClass);
        }
      }, LOP_CONFIG.navigationDelay);
    }

    /**
     * Manejar hover en swatch
     */
    handleSwatchHover(swatch, isEntering) {
      if (isEntering) {
        swatch.classList.add(LOP_CONFIG.hoverClass);
        
        // Aquí podrías implementar la lógica para cambiar la imagen del product card
        const productHandle = swatch.dataset.productHandle;
        if (productHandle) {
          // Buscar el product card padre
          const productCard = swatch.closest('product-card');
          if (productCard) {
            // Aquí podrías cambiar la imagen del product card
            console.log(`Product Card LOP: Hover en ${productHandle}`);
          }
        }
      } else {
        swatch.classList.remove(LOP_CONFIG.hoverClass);
      }
    }

    /**
     * Manejar focus en swatch
     */
    handleSwatchFocus(swatch) {
      const productHandle = swatch.dataset.productHandle;
      if (productHandle) {
        console.log(`Product Card LOP: Focus en ${productHandle}`);
      }
    }

    /**
     * Observar cambios en el DOM
     */
    observeDOM() {
      const observer = new MutationObserver((mutations) => {
        let shouldCheck = false;
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList && node.classList.contains(LOP_CLASSES.swatchItem)) {
                  shouldCheck = true;
                } else if (node.querySelector && node.querySelector(`.${LOP_CLASSES.swatchItem}`)) {
                  shouldCheck = true;
                }
              }
            });
          }
        });
        
        if (shouldCheck) {
          setTimeout(() => {
            this.checkForNewSwatches();
          }, 100);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    /**
     * Verificar nuevos swatches
     */
    checkForNewSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const initializedSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}[data-lop-initialized]`);
      
      if (allSwatches.length > initializedSwatches.length) {
        console.log(`Product Card LOP: Detectados ${allSwatches.length - initializedSwatches.length} nuevos swatches`);
        
        allSwatches.forEach((swatch, index) => {
          if (!swatch.hasAttribute('data-lop-initialized')) {
            this.setupSwatch(swatch, index);
            swatch.setAttribute('data-lop-initialized', 'true');
          }
        });
      }
    }

    /**
     * Verificar swatches después de la carga
     */
    checkSwatchesAfterLoad() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => {
            this.checkForNewSwatches();
          }, 500);
        });
      } else {
        setTimeout(() => {
          this.checkForNewSwatches();
        }, 500);
      }
    }

    /**
     * Verificar que todos los swatches estén funcionando
     */
    verifyAllSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Verificando ${allSwatches.length} swatches`);
      
      allSwatches.forEach((swatch, index) => {
        if (swatch.dataset.productHandle) {
          // Asegurar que el swatch sea clickeable
          swatch.style.pointerEvents = 'auto';
          swatch.style.cursor = 'pointer';
          
          // Verificar que tenga los atributos necesarios
          if (!swatch.hasAttribute('data-lop-verified')) {
            swatch.setAttribute('data-lop-verified', 'true');
            console.log(`Product Card LOP: Swatch ${index} verificado - ${swatch.dataset.productHandle}`);
          }
        } else {
          console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        }
      });
      
      return allSwatches.length;
    }

    /**
     * Función de utilidad para debug
     */
    debug() {
      console.log('Product Card LOP: Debug info');
      console.log('Config:', LOP_CONFIG);
      console.log('Classes:', LOP_CLASSES);
      
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Total swatches: ${allSwatches.length}`);
      
      allSwatches.forEach((swatch, index) => {
        console.log(`Swatch ${index}:`, {
          handle: swatch.dataset.productHandle,
          color: swatch.dataset.productColor,
          tooltip: swatch.dataset.tooltip,
          isCurrent: swatch.dataset.isCurrentProduct
        });
      });
    }

    /**
     * Verificar productos relacionados en un product card específico
     */
    debugProductCard(productCard) {
      if (!productCard) {
        console.log('Product Card LOP: No se proporcionó product card');
        return;
      }

      const swatches = productCard.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const productTitle = productCard.querySelector('.product-card-title')?.textContent || 'Sin título';
      
      console.log(`Product Card LOP: Debug para "${productTitle}"`);
      console.log(`Swatches encontrados: ${swatches.length}`);
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const color = swatch.dataset.productColor;
        const tooltip = swatch.dataset.tooltip;
        
        console.log(`  Swatch ${index + 1}:`);
        console.log(`    Handle: ${handle}`);
        console.log(`    Color: ${color}`);
        console.log(`    Tooltip: ${tooltip}`);
        
        // Intentar obtener información del producto relacionado
        if (handle) {
          // Aquí podrías hacer una llamada AJAX para obtener más info del producto
          console.log(`    URL: /products/${handle}`);
        }
      });
    }

    /**
     * Verificar todos los product cards en la página
     */
    debugAllProductCards() {
      const productCards = document.querySelectorAll('product-card');
      console.log(`Product Card LOP: Debug de ${productCards.length} product cards`);
      
      productCards.forEach((card, index) => {
        const title = card.querySelector('.product-card-title')?.textContent || 'Sin título';
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        
        console.log(`Product Card ${index + 1}: "${title}" - ${swatches.length} swatches`);
        
        if (swatches.length > 0) {
          swatches.forEach((swatch, swatchIndex) => {
            console.log(`  - Swatch ${swatchIndex + 1}: ${swatch.dataset.productHandle}`);
          });
        }
      });
    }

    /**
     * Verificar si los productos del agrupador existen
     */
    debugAgrupadorProducts(agrupadorString) {
      if (!agrupadorString) {
        console.log('Product Card LOP: No se proporcionó agrupador');
        return;
      }

      try {
        // Parsear el JSON del agrupador
        const agrupador = JSON.parse(agrupadorString);
        console.log(`Product Card LOP: Agrupador parseado - ${agrupador.length} productos`);
        
        agrupador.forEach((handle, index) => {
          console.log(`Producto ${index + 1}: ${handle}`);
          
          // Verificar si el producto existe haciendo una petición
          fetch(`/products/${handle}.js`)
            .then(response => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error(`Producto no encontrado: ${handle}`);
              }
            })
            .then(product => {
              console.log(`  ✓ ${handle} - ${product.title}`);
            })
            .catch(error => {
              console.log(`  ✗ ${handle} - ${error.message}`);
            });
        });
      } catch (error) {
        console.error('Product Card LOP: Error parseando agrupador:', error);
      }
    }

    /**
     * Cargar datos de productos dinámicamente
     */
    loadProductData(handle) {
      return fetch(`/products/${handle}.js`)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(`Producto no encontrado: ${handle}`);
          }
        })
        .catch(error => {
          console.error(`Product Card LOP: Error cargando ${handle}:`, error);
          return null;
        });
    }

    /**
     * Actualizar swatch con datos del producto
     */
    updateSwatchWithProductData(swatch, productData) {
      if (!productData) return;

      // Actualizar imagen si está disponible
      if (productData.featured_image) {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        if (swatchImage) {
          // Si es un div (fallback), convertirlo a img
          if (swatchImage.tagName === 'DIV') {
            const newImg = document.createElement('img');
            newImg.src = productData.featured_image;
            newImg.alt = productData.title;
            newImg.className = 'LOP-product-card-swatch-image';
            newImg.loading = 'lazy';
            swatchImage.parentNode.replaceChild(newImg, swatchImage);
          } else {
            // Si ya es una img, actualizar src
            swatchImage.src = productData.featured_image;
            swatchImage.alt = productData.title;
          }
        }
      }

      // Actualizar tooltip
      if (productData.title) {
        swatch.dataset.tooltip = productData.title;
      }

      // Actualizar color si está disponible
      if (productData.options && productData.options.length > 0) {
        const firstOption = productData.options[0];
        if (firstOption.values && firstOption.values.length > 0) {
          swatch.dataset.productColor = firstOption.values[0];
        }
      }

      console.log(`Product Card LOP: Swatch actualizado con datos de ${productData.title}`);
    }

    /**
     * Cargar datos de productos para swatches que no están en all_products
     */
    loadMissingProductData() {
      console.log('Product Card LOP: Cargando datos de productos faltantes...');
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Encontrados ${swatches.length} swatches para verificar`);
      
      let loadedCount = 0;
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        if (handle) {
          // Verificar si el swatch tiene datos básicos
          const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
          const hasImage = swatchImage && swatchImage.src && !swatchImage.src.includes('placeholder');
          const hasText = swatchImage && swatchImage.textContent && swatchImage.textContent.includes('Ver');
          
          if (!hasImage || hasText) {
            console.log(`Product Card LOP: Cargando datos para swatch ${index + 1} - ${handle}`);
            // Cargar datos del producto
            this.loadProductData(handle).then(productData => {
              if (productData) {
                console.log(`Product Card LOP: Datos cargados para ${handle} - ${productData.title}`);
                this.updateSwatchWithProductData(swatch, productData);
                loadedCount++;
              }
            }).catch(error => {
              console.log(`Product Card LOP: Error cargando ${handle}:`, error);
            });
          }
        }
      });
      
      console.log(`Product Card LOP: Iniciada carga de ${loadedCount} productos`);
    }

    /**
     * Verificar estado del fallback y swatches
     */
    debugFallbackStatus() {
      console.log('Product Card LOP: Verificando estado del fallback...');
      
      const productCards = document.querySelectorAll('product-card');
      let totalCards = 0;
      let cardsWithAgrupador = 0;
      let cardsWithSwatches = 0;
      let cardsWithFallback = 0;
      
      productCards.forEach((card, index) => {
        const title = card.querySelector('.product-card-title')?.textContent || 'Sin título';
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        const debugInfo = card.querySelector('[style*="background: #f0f0f0"]');
        
        totalCards++;
        
        if (debugInfo) {
          cardsWithAgrupador++;
          
          if (swatches.length > 0) {
            cardsWithSwatches++;
            
            // Verificar si son swatches de fallback
            const fallbackSwatches = card.querySelectorAll('.LOP-product-card-swatch-item[data-product-color="Variante"]');
            if (fallbackSwatches.length > 0) {
              cardsWithFallback++;
              console.log(`  Card ${index + 1}: "${title}" - ${swatches.length} swatches (${fallbackSwatches.length} fallback)`);
            } else {
              console.log(`  Card ${index + 1}: "${title}" - ${swatches.length} swatches (normales)`);
            }
          } else {
            console.log(`  Card ${index + 1}: "${title}" - 0 swatches`);
          }
        } else {
          console.log(`  Card ${index + 1}: "${title}" - Sin agrupador`);
        }
      });
      
      console.log(`Product Card LOP: Resumen:`);
      console.log(`  Total cards: ${totalCards}`);
      console.log(`  Cards con agrupador: ${cardsWithAgrupador}`);
      console.log(`  Cards con swatches: ${cardsWithSwatches}`);
      console.log(`  Cards con fallback: ${cardsWithFallback}`);
      
      return {
        totalCards,
        cardsWithAgrupador,
        cardsWithSwatches,
        cardsWithFallback
      };
    }

    /**
     * Verificar estado actual de los swatches
     */
    checkCurrentSwatchStatus() {
      console.log('Product Card LOP: Verificando estado actual de swatches...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let fallbackSwatches = 0;
      let normalSwatches = 0;
      let emptySwatches = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (swatchImage) {
          if (swatchImage.tagName === 'DIV' && swatchImage.textContent.includes('Ver')) {
            fallbackSwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - FALLBACK (necesita carga)`);
          } else if (swatchImage.tagName === 'IMG' && swatchImage.src) {
            normalSwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - NORMAL (con imagen)`);
          } else {
            emptySwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - VACÍO`);
          }
        } else {
          emptySwatches++;
          console.log(`  Swatch ${index + 1}: ${handle} - SIN IMAGEN`);
        }
      });
      
      console.log(`Product Card LOP: Resumen de swatches:`);
      console.log(`  Total: ${swatches.length}`);
      console.log(`  Fallback (necesitan carga): ${fallbackSwatches}`);
      console.log(`  Normales (con imagen): ${normalSwatches}`);
      console.log(`  Vacíos: ${emptySwatches}`);
      
      return {
        total: swatches.length,
        fallback: fallbackSwatches,
        normal: normalSwatches,
        empty: emptySwatches
      };
    }

    /**
     * Forzar carga de datos para todos los swatches de fallback
     */
    forceLoadAllFallbackSwatches() {
      console.log('Product Card LOP: Forzando carga de todos los swatches de fallback...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let loadedCount = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (handle && swatchImage && swatchImage.tagName === 'DIV' && swatchImage.textContent.includes('Ver')) {
          console.log(`Product Card LOP: Cargando datos forzados para ${handle}`);
          
          this.loadProductData(handle).then(productData => {
            if (productData) {
              console.log(`Product Card LOP: Datos cargados exitosamente para ${handle} - ${productData.title}`);
              this.updateSwatchWithProductData(swatch, productData);
              loadedCount++;
            } else {
              console.log(`Product Card LOP: No se pudieron cargar datos para ${handle}`);
            }
          }).catch(error => {
            console.log(`Product Card LOP: Error cargando ${handle}:`, error);
          });
        }
      });
      
      console.log(`Product Card LOP: Iniciada carga forzada de ${loadedCount} productos`);
      return loadedCount;
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductCardLOP();
    });
  } else {
    new ProductCardLOP();
  }

  // Exponer para debugging
  window.ProductCardLOP = ProductCardLOP;
  
  // Función global para debugging
  window.debugProductCardLOP = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debug();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para debug de product cards específicos
  window.debugProductCard = function(productCard) {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugProductCard(productCard);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para debug de todos los product cards
  window.debugAllProductCards = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugAllProductCards();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para verificar productos del agrupador
  window.debugAgrupadorProducts = function(agrupadorString) {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugAgrupadorProducts(agrupadorString);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para cargar datos de productos faltantes
  window.loadMissingProductData = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.loadMissingProductData();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para cargar datos de un producto específico
  window.loadProductData = function(handle) {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.loadProductData(handle);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return Promise.reject('Instancia no encontrada');
    }
  };

  // Función para verificar estado del fallback
  window.debugFallbackStatus = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugFallbackStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar estado actual de swatches
  window.checkCurrentSwatchStatus = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.checkCurrentSwatchStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para forzar carga de swatches de fallback
  window.forceLoadAllFallbackSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.forceLoadAllFallbackSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

})(); 